import { createAction } from 'redux-actions'

import {
  GET_WORKFLOW_STEP_EMAIL,
  GET_WORKFLOW_STEP_EMAIL_FAILED,
  GET_WORKFLOW_STEP_EMAIL_SUCCEEDED,
} from 'Redux/Types/WorkFlowStepTypes'

export const getWorkFlowStepReviewEmail = createAction(GET_WORKFLOW_STEP_EMAIL)
export const getWorkFlowStepReviewEmailFailed = createAction(GET_WORKFLOW_STEP_EMAIL_FAILED)
export const getWorkFlowStepReviewEmailSucceeded = createAction(GET_WORKFLOW_STEP_EMAIL_SUCCEEDED)
